import { Box, Typography } from "@mui/material";
import { Lock } from "iconsax-react";
import { useState } from "react";
import RoundButton from "../shared/components/round-btn";
import SyncModal from "./sync-modal";
import styles from './view-card.module.scss';

const PrivateCardHeader = ({cardId, uiStore, context, history}) => {

    const [showSyncModal, setShowSyncModal] = useState(false);

    const onSyncClick = () => {
        if(context.authenticatedUser.id) {
            setShowSyncModal(true);
        } else {
            history.push('/login?redirect=/card/' + cardId);
        }
    };

    return (
        <Box className={styles.wrapper}>
            <Box className={styles.cardBackground}></Box>
            <Box className={styles.header}>
                <Box className={styles.cardImg}>
                    <Lock variant="Bulk" size={70} />
                </Box>
                <Box className={styles.cardMeta} sx={{justifyContent: 'center', alignContent: 'center'}}>
                    <Box>
                        <Typography fontSize="16px" fontWeight="600">
                            Private Card
                        </Typography>
                    </Box>

                    <Box className={styles.metaContiner}>
                        <Box className={styles.cardActions}>
                            <Box className={styles.cardName}>
                            </Box>
                        </Box>
                        <Box className={styles.actionBtns}>
                            <RoundButton
                                variant="contained"
                                color="primary"
                                sx={{ mb: 2 }}
                                onClick={onSyncClick}
                            >
                                Request Access
                            </RoundButton>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <SyncModal show={showSyncModal} setShow={setShowSyncModal} uiStore={uiStore} cardId={cardId} />

        </Box>
    );
}

export default PrivateCardHeader;